import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { PreloadScene } from './scenes/PreloadScene';
import { MineScene } from './scenes/MineScene';
import { WORLD_WIDTH } from './layout';

export function createPhaserGame(parent: HTMLElement): Phaser.Game {
  const config: Phaser.Types.Core.GameConfig = {
    type: Phaser.AUTO,
    parent,
    backgroundColor: '#4A2F1D',
    scale: {
      mode: Phaser.Scale.RESIZE,
      width: WORLD_WIDTH,
      height: 1920,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    scene: [BootScene, PreloadScene, MineScene],
    banner: false,
    audio: { noAudio: true },
  };
  return new Phaser.Game(config);
}
